var _circle, _circle2, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRefreshButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 49,
    stroke: "#E8EDF2",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 44,
    fill: "#E8EDF2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.4244 68.943C35.8824 69.0489 35.5289 69.5742 35.6348 70.1162L37.3609 78.9492C37.4668 79.4912 37.992 79.8447 38.5341 79.7388C39.0761 79.6329 39.4296 79.1076 39.3237 78.5656L37.7894 70.7141L45.6409 69.1798C46.183 69.0739 46.5365 68.5486 46.4306 68.0066C46.3247 67.4645 45.7994 67.111 45.2574 67.2169L36.4244 68.943ZM73.0002 49.9999C73.0002 62.7025 62.7028 72.9999 50.0002 72.9999V74.9999C63.8073 74.9999 75.0002 63.807 75.0002 49.9999H73.0002ZM72.1324 43.719C72.6975 45.7143 73.0002 47.8209 73.0002 49.9999H75.0002C75.0002 47.6349 74.6715 45.3449 74.0567 43.174L72.1324 43.719ZM50.0002 72.9999C45.2497 72.9999 40.8383 71.5608 37.1746 69.0949L36.0578 70.754C40.0413 73.4352 44.8395 74.9999 50.0002 74.9999V72.9999Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1711 34.2452C67.7234 34.2521 68.1767 33.8101 68.1836 33.2578L68.2967 24.2586C68.3036 23.7063 67.8616 23.253 67.3093 23.2461C66.7571 23.2391 66.3038 23.6812 66.2968 24.2334L66.1963 32.2328L58.197 32.1323C57.6447 32.1254 57.1914 32.5674 57.1845 33.1197C57.1776 33.6719 57.6196 34.1252 58.1719 34.1322L67.1711 34.2452ZM27 50C27 37.2975 37.2975 27 50 27V25C36.1929 25 25 36.1929 25 50H27ZM50 27C56.456 27 62.2893 29.6587 66.4678 33.9435L67.8996 32.5471C63.3603 27.8923 57.017 25 50 25V27ZM29.0685 59.5467C27.7405 56.6401 27 53.4079 27 50H25C25 53.7004 25.8046 57.2155 27.2493 60.3778L29.0685 59.5467Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshButton);
export default __webpack_public_path__ + "static/media/refresh-button.98a06c5c0c22c2cfd221b96332aa6a9f.svg";
export { ForwardRef as ReactComponent };